export default __webpack_public_path__ + "static/media/actionTodoNoResult.8e91e55a.svg";